import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// Plan interval switch: show the annual saving vs 12 × monthly on the annual segment.
export default class ShowAnnualSaving extends BaseOption {
  static userInterfaceComponent = {
    label: "Show Annual Saving",
    component: inspectorTools.RADIO_BAR,
    optionDataType: BaseOption.DataType.Boolean,
    props: {
      options: [
        { label: "Yes", value: true, tooltip: "" },
        { label: "No", value: false, tooltip: "" },
      ],
    },
  };

  static defaultValue = true;
}
